import { PolicyMeta } from '@/lib/models/policy-model';
import { PolicyMeta as PolicyMetaV1 } from '@/lib/models/policy-model-v1';
import { ScrollAnchorId } from '../scroll-anchor/helpers';

export const getPolicyLink = (
  policy: PolicyMeta | PolicyMetaV1,
  hasPolicyV2: boolean,
  tab?: string,
  scrollId?: ScrollAnchorId
): string => {
  const { isDefault, id } = policy;

  let href = isDefault ? '/config/default-policy' : `/config/group-policies/${id}`;

  if (hasPolicyV2) {
    href = isDefault ? '/config/policy/default' : `/config/policy/scoped/${id}`;
  }

  if (tab) {
    href = `${href}?tab=${tab}`;
  }

  if (scrollId) {
    href = `${href}#${scrollId}`;
  }

  return href;
};
